import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { faEdit, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import TextField from '../../../../../components/TextField';
import ModalCustomized from '../../../../../components/Modal/Modal';
import TabelaListagem from '../../../../../components/TabelaListagem/TabelaListagem';

//Constants
import { actionsTable } from '../../../../../constants/MaterialTable';

//Api
import tipoRequerimento_api from '../../../../../api/tipoRequerimento_api';
import documento_api from '../../../../../api/documento_api';

//Context
import { useAuth } from '../../../../../context/auth';

//Helpers
import mascaras from '../../../../../helpers/mascaras';
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage, showQuestion } from '../../../../../helpers/message';

const initialStateDocumento = (idTipoRequerimento) => {
    return {
        ...idTipoRequerimento ? { tipoRequerimento_Id: idTipoRequerimento } : {},
        documento_Id: "",
        obrigatorio: "",
    }
}
export default function Identificacao({ tipoRequerimento, setTipoRequerimento, loadTipoRequerimento, editavel }) {
    const { setLoading } = useAuth();

    //Estado de controle dos erros
    const [errors, setErrors] = useState({});

    //Estado de controle dos erros nos campos do documento
    const [errorsDocumento, setErrosDocumento] = useState({});

    //Estado de controle de visibilidade do modal
    const [visibleModal, setVisibleModal] = useState(false);

    const toggleModal = () => {
        setVisibleModal(!visibleModal);
        if (!visibleModal) {
            setDocumento(initialStateDocumento(tipoRequerimento.id));
            setErrosDocumento({});
        }
    };

    //Estado de controle dos dados do documento a ser adicionado na lista
    const [documento, setDocumento] = useState(initialStateDocumento(tipoRequerimento.id));

    //Campos obrigatorios
    const camposIdentificacao = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "valorTaxaVistoria", required: true, number: true }),
        objCampo({ name: "requerente", required: true }),
        objCampo({ name: "arquivo", required: true }),
    ];

    //Campos obrigatorios
    const camposDocumento = [
        objCampo({ name: "documento_Id", required: true }),
        objCampo({ name: "obrigatorio", required: true }),
    ];

    const editar = (editRow) => {
        setDocumento(editRow);
    }
    const remover = (questaoRemove) => {
        showQuestion("Tem certeza?", "tem certeza de que deseja deletar esse documento?\n Esta ação é irreversível", "info",
            (confirmation) => {
                if (confirmation) {
                    setTipoRequerimento({
                        ...tipoRequerimento,
                        tipoRequerimentoDocumentos: tipoRequerimento.tipoRequerimentoDocumentos.filter(value => value.tableData.id != questaoRemove.tableData.id)
                    });
                }
            })
    }
    //Ações que a tabela terá
    const actions = [
        ...editavel ?
            [
                actionsTable.editar(editar),
                actionsTable.remover(remover)
            ]
            : []
    ];


    //Cabeçalhos que a tabela terá
    const headers = [
        {
            value: "Documento", objectValue: "documento_Id", align: "left", options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div>
                            {documentos.filter(documento => documento.id == tipoRequerimento.tipoRequerimentoDocumentos[dataIndex].documento_Id)[0].identificacao}
                        </div>
                    )
                }
            },
        },
        {
            value: "Obrigatorio", objectValue: "obrigatorio", align: "left", options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div>
                            {tipoRequerimento.tipoRequerimentoDocumentos[dataIndex].obrigatorio == "true" ? "Sim" : "Não"}
                        </div>
                    )
                }
            }
        }
    ]

    //Função de validação do step de identificação
    const onSubmitTipoRequerimento = () => {
        const _errors = validarCampos(tipoRequerimento, camposIdentificacao);
        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return;

        const _tipoRequerimento = { ...tipoRequerimento }
        delete _tipoRequerimento.tipoRequerimentoEtapas;
        delete _tipoRequerimento.tipoRequerimentoEtapasAcoes;
        _tipoRequerimento.valorTaxaVistoria = _tipoRequerimento.valorTaxaVistoria.replace(",", ".");
        setLoading(true);
        if (tipoRequerimento.id) {
            tipoRequerimento_api.putTipoRequerimento(_tipoRequerimento).then(response => {
                showMessage("Sucesso", "Sucesso ao atualizar o tipo de requerimento!", 'success', () => loadTipoRequerimento());
            }).catch(ex => {
                showMessage("Erro", ex.message, 'error', null);
            }).finally(f => setLoading(false));
        } else {
            tipoRequerimento_api.postTipoRequerimento(_tipoRequerimento).then(response => {
                showMessage("Sucesso", "Sucesso ao cadastrar o tipo de requerimento!", 'success', () => loadTipoRequerimento(response.data.id));
            }).catch(ex => {
                showMessage("Erro", ex.message, 'error', null);
            }).finally(f => setLoading(false));
        }
    };

    //Função de salvamento dos insert do documento
    const onSubmitDocumento = () => {
        const _documento = { ...documento };

        const _errorsDocumento = validarCampos(_documento, camposDocumento);
        setErrosDocumento(_errorsDocumento[0]);
        if (_errorsDocumento[1].length > 0)
            return;

        if (tipoRequerimento.tipoRequerimentoDocumentos.filter(x => x.documento_Id == _documento.documento_Id && (!_documento.id || _documento.id != x.id)).length > 0) {
            showMessage("Aviso", "Este documento ja foi adicionado para este tipo de requerimento", "info", null);
            return;
        }
        const _tipoRequerimentoDocumentos = [...!_documento.id
            ? tipoRequerimento.tipoRequerimentoDocumentos
            : tipoRequerimento.tipoRequerimentoDocumentos.map(value => {
                if (value.id == _documento.id)
                    return _documento;
                return value;
            })];

        if (!_documento.id) {
            _tipoRequerimentoDocumentos.push(_documento);
        }

        setTipoRequerimento({
            ...tipoRequerimento,
            tipoRequerimentoDocumentos: _tipoRequerimentoDocumentos
        });
        setDocumento(initialStateDocumento(tipoRequerimento.id));
    }

    //Estado de controle do onChange
    const onChange = (e) => {
        const { name, value } = e.target;

        setTipoRequerimento({
            ...tipoRequerimento,
            [name]: value
        })
    }
    //Função de onChange do arquivo de anexo
    const onChangeArquivo = (e) => {
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            const base64 = evt.target.result;
            setTipoRequerimento({
                ...tipoRequerimento,
                arquivo: base64
            });
        });
        if (e.target.files)
            FR.readAsDataURL(e.target.files[0]);
    }

    //Estado de controle das opções de documentos
    const [documentos, setDocumentos] = useState([]);

    //onChange para o documento a ser adicionado
    const onChangeDocumento = (value, e) => {
        setDocumento({
            ...documento,
            [e.name]: value ? value.value : null,
        });

    }

    //onChange do campo obrigatorio do documento
    const onChangeObrigatorioDocumento = (e) => {
        const { name, value } = e.target;

        setDocumento({
            ...documento,
            [name]: value
        })
    }

    //Carrega os documentos para o cadastro da etapa
    const loadDocumentos = () => {
        documento_api.getList("Ativo").then(response => {
            setDocumentos(response.data.map(value => {
                value.id = value.id.toString();
                return value;
            }));
        }).catch(e => showMessage("Erro", e.message, "error", null))
    }

    useEffect(() => {
        loadDocumentos();
    }, []);
    return (
        <>
            <ModalCustomized isOpen={visibleModal} toggle={toggleModal} btnClose={true} title={"Documentos"}>
                <Row>
                    {editavel &&
                        (
                            <>
                                <Col md="12" lg="8">
                                    <TextField
                                        label={"* Documento"}
                                        name={"documento_Id"}
                                        onChange={onChangeDocumento}
                                        type={"select"}
                                        searchable
                                        options={documentos.map(value => { return { value: value.id, label: value.identificacao } })}
                                        value={
                                            documentos.filter(doc => doc.id === documento.documento_Id).map(value => { return { value: value.id, label: value.identificacao } })
                                        }
                                        invalid={!!errorsDocumento.documento_Id}
                                        disabled={!editavel}
                                    />
                                </Col>
                                <Col md="12" lg="4">
                                    <TextField
                                        type={"radio"}
                                        label="* Obrigatorio"
                                        name={"obrigatorio"}
                                        options={
                                            [
                                                { label: "Sim", value: "true" },
                                                { label: "Não", value: "false" }
                                            ]
                                        }
                                        onChange={onChangeObrigatorioDocumento}
                                        value={documento.obrigatorio}
                                        invalid={!!errorsDocumento.obrigatorio}
                                        disabled={!editavel}
                                    />
                                </Col>
                                <Col md="12" className='d-flex align-items-center justify-content-center mb-4 '>
                                    <Button color={"secondary"} className='me-4' onClick={() => setDocumento(initialStateDocumento(tipoRequerimento.id))}>
                                        cancelar
                                    </Button>
                                    <Button onClick={onSubmitDocumento} color={documento.id ? "warning text-white" : 'success'}>
                                        {documento.id ? <> <FontAwesomeIcon icon={faEdit} />  Editar</> : "+ Adicionar"}
                                    </Button>
                                </Col>
                            </>
                        )}
                    <Col md="12" className='d-flex align-items-center justify-content-center'>
                        <TabelaListagem title='Lista de documentos' headers={headers} actions={actions} items={tipoRequerimento.tipoRequerimentoDocumentos} />
                    </Col>
                </Row>
            </ModalCustomized>
            <Row>
                <h5 className='mb-3'>Identificação do tipo de requerimento</h5>
                <Col md="12" lg="6">
                    <TextField
                        label={"Identificação"}
                        name={"identificacao"}
                        maxLength={100}
                        onChange={onChange}
                        value={tipoRequerimento.identificacao}
                        invalid={!!errors.identificacao}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" lg="3">
                    <TextField
                        label={"Valor da taxa de vistoria"}
                        name={"valorTaxaVistoria"}
                        onChange={onChange}
                        value={tipoRequerimento.valorTaxaVistoria}
                        invalid={!!errors.valorTaxaVistoria}
                        mask={mascaras.floatMask}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" lg="3">
                    <Button className='mt-2 w-100' color='primary' onClick={toggleModal}>
                        Documentos
                    </Button>
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        label={"* Requerente"}
                        name={"requerente"}
                        onChange={onChange}
                        type={"select"}
                        options={[
                            { value: "Munícipe", label: "Munícipe" },
                            { value: "Órgão Público", label: "Órgão Público" },
                        ]}
                        value={tipoRequerimento.requerente}
                        invalid={!!errors.requerente}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        label={"* Icone"}
                        name={"arquivo"}
                        onChange={onChangeArquivo}
                        type={"file"}
                        value={tipoRequerimento.onChangeArquivo}
                        invalid={!!errors.onChangeArquivo}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        type={"radio"}
                        label="* Status"
                        name={"status"}
                        options={
                            [
                                { label: "Ativo", value: "Ativo" },
                                { value: "Inativo", label: "Inativo" }
                            ]
                        }
                        onChange={onChange}
                        value={tipoRequerimento.status}
                        invalid={!!errors.status}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" lg="12" className='d-flex align-items-center justify-content-center mb-4'>
                    {tipoRequerimento.arquivo &&
                        <img src={tipoRequerimento.arquivo} width={150} />
                    }
                </Col>
                <Col md="12" lg="12" className='d-flex align-items-center justify-content-center'>
                    {editavel &&
                        <Button className='px-4' color='success' onClick={onSubmitTipoRequerimento}><FontAwesomeIcon icon={faSave} /> Salvar</Button>
                    }
                </Col>
            </Row>
        </>
    )
}